import axios from 'axios';
import API_BASE_URL from '../config';

const TOKEN_KEY = 'jwt_token';

const client = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false,
  timeout: 120000,
});

client.interceptors.request.use((config) => {
  const token = sessionStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      sessionStorage.removeItem(TOKEN_KEY);
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export const storeAccessToken = (token) => {
  if (token) {
    sessionStorage.setItem(TOKEN_KEY, token);
  } else {
    sessionStorage.removeItem(TOKEN_KEY);
  }
};

export const getStoredToken = () => sessionStorage.getItem(TOKEN_KEY);

export default client;

